import * as dd from 'dingtalk-jsapi';

const isWeiXin = function () {
  const ua = navigator.userAgent.toLowerCase()
  return ua.includes('micromessenger') // true or false
}

const isDingDing = function () {
  const ua = window.navigator.userAgent
  return ua.includes('DingTalk') // true or false
}

const changeDocumentTitle = function (title) {
  // 钉钉浏览器内部，使用钉钉提供的JSAPI中的接口dd.biz.navigation.setTitle设置导航栏标题
  if (window.navigator.userAgent.includes('DingTalk')) {
    dd.biz.navigation.setTitle({
      title,
      onSuccess: (result) => {
        console.log(result);
      },
      onFail: (err) => {
        console.log(err);
      }
    })
  } else document.title = title;// 其他浏览器
}

export {
  isWeiXin,   // 是否是微信环境
  isDingDing,  // 是否是钉钉环境
  changeDocumentTitle // 设置导航栏标题
}



// WEBPACK FOOTER //
// ./src/service/environment.js